import React from 'react'
import Layout from '../../components/Layout'
import Intro from './Intro';
import Projekte from './Projekte';

const Clients = () => {
  return (
    <Layout>
      <Intro />
      <Projekte />
    </Layout>
  )
}

export default Clients;